<template>
    <div class="content_module">
            <div class='content'>
                <p class='title1'>{{product_advantage.title}}</p>
                <p class='title2'>{{product_advantage.value}}</p>
                <p class='title3'><span></span></p>

                <ul>
                    <li v-if="product_advantage.click" v-for="item in product_advantage.items" @click="select(item)">
                        <div class="circle" :class="{'cir_show':item.show}" :style="item.style">
                        <div v-html='item.name'></div>
                        </div>
                        <span :style="item.line_style" :class="{span_show:!item.img_show}"></span>
                    </li>
                    <li v-if="!product_advantage.click" v-for="item in product_advantage.items">
                        <div class="circle" :class="{'cir_show':item.show}" :style="{backgroundColor:item.bg_color,}">
                        <div v-html='item.name'></div>
                        </div>
                        <span :style="item.line_style" :class="{span_show:!item.img_show}"></span>
                    </li>
                </ul>
                
                <div v-if="product_advantage.img_src" style="width:100%;margin-top:40px;">
                    <img width="80%" style="width:80%;height:auto;margin-bottom:-30px;" :src="product_advantage.img_src"/>
                </div>
                <div v-for="item in product_advantage.items" class="model" v-if="item.show" v-html="item.mes"></div>
            </div>
    </div>
</template>

<script>
export default {
  name: 'product-advantage',
  props:["product_advantage"],
  data () {
    return {
    }
  },
  created:function(){
    let self = this;
  },
  methods:{
    select(item){
        let self = this;
        for(let i in self.product_advantage.items){
            let cir = self.product_advantage.items[i];
            console.log(cir);
            if(cir.show==true){
                cir.show = false;
                break;
            }
        }
        item.show=true;
    }
  }
}
</script>

<style scoped>
@import '../../../../static/css/common.css';

.content_module{
    background-color:#f9fafc;
}

.content_module .back{
    position:absolute;
    z-index:0;
    width:100%;
    top:auto;
    height:1em;
    text-align:center;
    font-size:360px;
    overflow:hidden;
    margin:0 auto;
    bottom:250px;
    color:rgba(245,248,255,0.4);
}

.content{
    width:900px;
    margin:0 auto;
    position:relative;
    display:flex;
    justify-content:center;
    flex-wrap:wrap;
    padding-bottom:30px;
}

ul{
    width:100%;
    display:flex;
    justify-content:space-between;
    margin-top:30px;
}

li{
    list-style:none;
    display:flex;
    align-items:center;
    flex:1 1 auto;
    justify-content:flex-start;
}
ul li .circle{
    padding-bottom:50%;
    width:50%;
    height:0px;
    font-size:16px;
    color:#fff;
    border-radius:50%;
    display:flex;
    justify-content:center;
    position:relative;
    align-items:center;
    cursor:pointer;
}
ul li .circle div{
    width:100%;
    height:100%;
    font-size:16px;
    position:absolute;
    color:#fff;
    display:flex;
    justify-content:center;
    bottom:0;
    align-items:center;
}

ul li span{
    line-height:80px;
    margin:0 5px;
    height:8px;
    mask:url(/static/image/product_center/arrow.svg);
    flex:1 0 auto;
    animation: move-arrows .5s linear infinite;
    transform-origin: left;
    background-image: linear-gradient(100grad,#6f94f0,#6f94f0);
}
ul li .span_show{
		visibility: hidden;
        }
@keyframes move-arrows{
    to{-webkit-mask-position:11px 0;mask-position:11px 0}
}
ul li .cir_show{
    width:65%;
    height:0px;
    font-size:18px;
    font-weight:600;
    padding-bottom:65%;
}
ul li .cir_show div{
    font-size:1.05em;
    font-weight:600;
}

.model{
    width:100%;
    height:auto;
    background-color:#fff;
    text-align:center;
    font-size:14px;
    color:#575757;
    padding:25px 0;
    margin-top:15px;
}
</style>
<style scoped>
@media screen and (max-width: 1000px) {

    ul li .circle div{
        font-size:4px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/product_center/product_advantage.vue